import React from 'react';
import { Field } from 'formik';

import styles from './resumePhoneFormStyles';

import FileField from 'buyside/components/presentation/Form/Field/FileField/fileField';
import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';

const ResumePhoneForm = () => {
  return (
    <div>
      <Field
        component={FileField}
        name="userProfile.resume"
        label="Resume"
        filefieldConfig={{ 'application/pdf': ['.pdf'] }}
      />
      <div className={styles.resumePhoneFormColumn}>
        <Field component={InputField} name="userProfile.workPhone" label="Phone" />
      </div>
    </div>
  );
};

export default ResumePhoneForm;
